import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

const experiences = [
  {
    title: 'Web Developer',
    company: 'Wikicampers',
    period: 'sept.2023 - Present',
    description:
      'Built a new app in React with Ionic Capacitor, managed APIs, and collaborated with design and product teams. Also worked on the Wikicampers website in Symfony to develop features and fix bugs.',
  },
  {
    title: 'Work-study program, developer',
    company: 'Wikicampers',
    period: 'nov.2022 - sept.2023',
    description:
      'Worked on PWA apps with Next.js and the Symfony website. Collaborated with design and product teams to improve the website and fix bugs.',
  },
  {
    title: 'Internship, developer',
    company: 'Ecreatures',
    period: 'jan. 2022 - feb. 2022',
    description:
      'Completed a 2-month internship at a tech company with Michel Perrin. Built a PWA app using Vue.js for fitness and nutrition tracking to improve my Vue.js skills. Later contributed to a Vue.js website for post-operative follow-up for a cosmetic surgeon.',
  },
  {
    title: 'Advanced programming school',
    company: 'IUT de Bayonne et du Pays Basque',
    period: '2022 - 2023',
    description:
      'Work-study program to dive into the professional world early and accelerate my learning through real-world experience.',
  },
];

const Experience = ({ experienceRef }: any) => {
  const iconRef = useRef(null);
  const isInView = useInView(iconRef, { once: false });

  return (
    <section
      ref={experienceRef}
      className="h-auto min-h-screen md:h-screen md:snap-start py-20 px-4 sm:px-6 lg:px-8 text-gray-900 dark:text-white flex items-center"
    >
      <div className="max-w-6xl mx-auto w-full">
        <motion.h2
          className="text-5xl md:text-6xl ralewaytitle mb-12 !italic mt-16 md:mt-0 text-center"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Experiences
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" ref={iconRef}>
          {experiences.map((exp, index) => (
            <motion.div
              key={index}
              className="rounded-xl shadow-lg overflow-hidden bg-gray-100 dark:bg-gray-900 border border-gray-300 dark:border-gray-700 transition"
              initial={{ opacity: 0 }}
              animate={isInView ? { opacity: 1 } : {}}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              {/* Header style Mac window */}
              <div className="flex items-center gap-2 p-3 bg-gray-200 dark:bg-gray-800">
                <span className="w-3 h-3 rounded-full bg-red-500" />
                <span className="w-3 h-3 rounded-full bg-yellow-500" />
                <span className="w-3 h-3 rounded-full bg-green-500" />
                <span className="ml-auto text-base text-gray-500 dark:text-gray-400 font-mono">
                  {exp.title.toLowerCase().replace(/\s/g, '-').replace(',', '')}.js
                </span>
              </div>

              {/* Code-style content */}
              <pre className="text-base font-mono p-4 whitespace-pre-wrap leading-relaxed bg-transparent text-left font-bold">
                <code>
                  <span className="text-purple-500 dark:text-purple-400">// {exp.title}</span>
                  {'\n'}
                  {'\n'}
                  <span className="text-yellow-700 dark:text-yellow-400">company</span>:{' '}
                  <span className="text-green-600 dark:text-green-400">"{exp.company}"</span>,
                  {'\n'}
                  <span className="text-yellow-700 dark:text-yellow-400">period</span>:{' '}
                  <span className="text-green-600 dark:text-green-400">"{exp.period}"</span>,
                  {'\n'}
                  <span className="text-yellow-700 dark:text-yellow-400">description</span>:{' '}
                  <span className="text-green-600 dark:text-green-400">"{exp.description}"</span>
                  {'\n'}
                </code>
              </pre>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
